import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Check if this is the first visit (no saved preference)
    if (typeof window !== 'undefined') {
      const saved = localStorage.getItem('preferredLanguage');
      // Only use saved preference if it exists, default to Chinese
      return saved || 'zh';
    }
    return 'zh';
  });

  // Track if this is initial load
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    // Only save to localStorage after user explicitly changes language
    if (isInitialized) {
      localStorage.setItem('preferredLanguage', language);
    } else {
      setIsInitialized(true);
    }
  }, [language, isInitialized]);

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'zh' ? 'en' : 'zh');
  };

  const isEnglish = language === 'en';
  const isChinese = language === 'zh';

  // Helper function to get text based on current language
  const getText = (zhText, enText) => {
    return language === 'zh' ? zhText : (enText || zhText);
  };

  const value = {
    language,
    setLanguage,
    toggleLanguage,
    isEnglish,
    isChinese,
    getText
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageContext;
